module.exports = __webpack_public_path__ + "static/img/telegram-banner-betting-slip.1f816f0.png";